module.exports = __webpack_public_path__ + "img/sem-foto.186ee886.png";